import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useViewClientNotePageRedirect = () => {
  const {
    doRedirectOnPrevPage,
    doRedirectWithSavePageUrl: redirectOnClientNotePage,
    prevPageUrl,
    doSavePageUrl,
  } = usePagesRedirect('ClientNotePage');

  return {
    doRedirectOnPrevPage,
    redirectOnClientNotePage,
    prevPageUrl,
    doSavePageUrl,
  };
};
